/* =========================================================
   CUSTOM.JS — SALPI (CLEAN + STABLE)
   - Footer drawer (#drawer:slug)
   - Desktop accordion toggle (sin romper mobile)
   - Footer slider 1 a 1 (lento)
   - Scroll lock SOLO cuando TU drawer está abierto (html.salpi-drawer-open)
   - Ship-to state: html.salpi-shipto-open (source of truth: .salpi-shipto-drawer[aria-hidden])
   - Stiletto localization (mobile drawer) FIX: fallback, NO pelea con el theme
   ========================================================= */

(function () {
  "use strict";

  const HTML = document.documentElement;
  const BODY = document.body;

  const isDesktop = () => window.matchMedia("(min-width: 990px)").matches;

  // Detecta si el drawer-menu nativo del theme está abierto (para no tocar su scroll-lock)
  const isThemeMenuOpen = () =>
    document.body.getAttribute("mobile-menu-open") === "true" ||
    !!document.querySelector(".drawer-menu.active");

  /* =========================
     A) Footer Drawer (#drawer:slug)
     ========================= */
  const DRAWER_ROUTES = {
    shipping: { title: "Shipping details", url: "/pages/shipping?view=drawer" },
    careguide: { title: "Care guide", url: "/pages/care-guide?view=drawer" },
    returns: { title: "Exchanges and returns", url: "/policies/refund-policy" },
    privacy: { title: "Privacy policy", url: "/policies/privacy-policy" },
    legalnotice: { title: "Legal notice", url: "/policies/legal-notice" },
    refund: { title: "Refund policy", url: "/policies/refund-policy" },
    shippingpolicy: { title: "Shipping policy", url: "/policies/shipping-policy" },
    termsofservice: { title: "Terms of service", url: "/policies/terms-of-service" },
  };

  const drawer = document.getElementById("salpiDrawer");
  const drawerBody = document.getElementById("salpiDrawerBody");
  const drawerTitle = document.getElementById("salpiDrawerTitle");
  const drawerFullLink = document.getElementById("salpiDrawerFullLink");

  function getLocalePrefix() {
    const m = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/i);
    return m ? `/${m[1]}` : "";
  }

  function withLocale(url) {
    if (!url) return url;
    const prefix = getLocalePrefix();
    if (!prefix) return url;

    if (url.startsWith(prefix + "/") || url === prefix) return url;

    if (url.startsWith("http")) {
      try {
        const u = new URL(url);
        if (u.origin === window.location.origin && !u.pathname.startsWith(prefix + "/")) {
          u.pathname = prefix + u.pathname;
        }
        return u.toString();
      } catch {
        return url;
      }
    }

    if (url.startsWith("/")) return prefix + url;
    return url;
  }

  function pickMainContent(doc) {
    const policy = doc.querySelector(".shopify-policy__container");
    if (policy) return policy;
    return doc.body;
  }

  // Scroll lock SOLO para TU drawer
  function lockScrollForDrawer() {
    HTML.classList.add("salpi-drawer-open");
    BODY.style.overflow = "hidden";
  }

  function unlockScrollForDrawer() {
    HTML.classList.remove("salpi-drawer-open");
    BODY.style.removeProperty("overflow");
    BODY.style.removeProperty("position");
    BODY.style.removeProperty("top");
    BODY.style.removeProperty("left");
    BODY.style.removeProperty("right");
    BODY.style.removeProperty("width");
  }

  function openDrawer({ title, url }) {
    if (!drawer || !drawerBody || !drawerTitle || !drawerFullLink) return;

    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    lockScrollForDrawer();

    drawerTitle.textContent = title || "Details";
    drawerBody.innerHTML = "<p>Loading…</p>";

    const finalUrl = withLocale(url);
    drawerFullLink.href = finalUrl || "#";

    if (!finalUrl) {
      drawerBody.innerHTML = "<p>No content.</p>";
      return;
    }

    fetch(finalUrl, { credentials: "same-origin" })
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const main = pickMainContent(doc);
        drawerBody.innerHTML = main ? main.innerHTML : "<p>Could not load content.</p>";
      })
      .catch(() => {
        drawerBody.innerHTML = "<p>Could not load content.</p>";
      });
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    unlockScrollForDrawer();
  }

  // Close buttons
  if (drawer) {
    drawer.querySelectorAll("[data-drawer-close]").forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        closeDrawer();
      });
    });
  }

  // ESC close
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeDrawer();
  });

  // Intercept #drawer:slug (pero NO dentro del drawer-menu del theme)
  document.addEventListener("click", (e) => {
    if (e.target.closest(".drawer-menu")) return;

    const a = e.target.closest("a");
    if (!a) return;

    const rawHref = a.getAttribute("href") || "";
    const absHref = a.href || "";
    const href = rawHref.includes("#drawer:") ? rawHref : absHref;

    if (!href.includes("#drawer:")) return;

    e.preventDefault();

    const slug = href.split("#drawer:")[1].trim();
    const route = DRAWER_ROUTES[slug];

    if (!route) {
      openDrawer({ title: "Details", url: null });
      if (drawerBody) drawerBody.innerHTML = "<p>Drawer route not found. Revisa slug y DRAWER_ROUTES.</p>";
      return;
    }

    openDrawer({ title: route.title, url: route.url });
  });

  // Limpieza del scroll-lock SOLO si tu drawer NO está abierto y el theme menu NO está abierto
  document.addEventListener("DOMContentLoaded", () => {
    if (!drawer || !drawer.classList.contains("is-open")) {
      if (!isThemeMenuOpen()) unlockScrollForDrawer();
    }
  });

  /* =========================
     B) Desktop Accordion (solo desktop)
     ========================= */
  function initFooterAccordionDesktop() {
    const groups = document.querySelectorAll(".footer .footer__group--collapse");
    if (!groups.length) return;

    groups.forEach((group) => {
      const btn = group.querySelector('button.footer__header[data-header]');
      if (!btn) return;

      if (btn.dataset.salpiBound === "1") return;
      btn.dataset.salpiBound = "1";

      if (isDesktop()) {
        group.classList.remove("salpi-acc-open");
        btn.setAttribute("aria-expanded", "false");
      }

      btn.addEventListener(
        "click",
        (ev) => {
          if (!isDesktop()) return;
          ev.preventDefault();
          ev.stopPropagation();
          if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();

          group.classList.toggle("salpi-acc-open");
          btn.setAttribute("aria-expanded", group.classList.contains("salpi-acc-open") ? "true" : "false");
        },
        true
      );
    });
  }

  document.addEventListener("DOMContentLoaded", initFooterAccordionDesktop);
  window.addEventListener("resize", initFooterAccordionDesktop);
  document.addEventListener("shopify:section:load", initFooterAccordionDesktop);

  /* =========================
     C) Footer Slider (desktop, 1 a 1)
     ========================= */
  let salpiSliderIntervalId = null;

  function initFooterSlider() {
    if (!isDesktop()) {
      if (salpiSliderIntervalId) {
        clearInterval(salpiSliderIntervalId);
        salpiSliderIntervalId = null;
      }
      return;
    }

    const slider = document.querySelector(".footer .salpi-footer-slider");
    if (!slider) return;

    const slides = Array.from(slider.querySelectorAll(".salpi-slide"));
    if (slides.length < 2) return;

    if (salpiSliderIntervalId) {
      clearInterval(salpiSliderIntervalId);
      salpiSliderIntervalId = null;
    }

    let idx = 0;
    slides.forEach((s) => s.classList.remove("is-active"));
    slides[0].classList.add("is-active");

    const DURATION = 7000;

    salpiSliderIntervalId = setInterval(() => {
      slides[idx].classList.remove("is-active");
      idx = (idx + 1) % slides.length;
      slides[idx].classList.add("is-active");
    }, DURATION);
  }

  document.addEventListener("DOMContentLoaded", initFooterSlider);
  window.addEventListener("resize", initFooterSlider);
  document.addEventListener("shopify:section:load", initFooterSlider);

  /* =========================
     D) Ship-to panel detector (STILETTO)
     Source of truth: .salpi-shipto-drawer[aria-hidden]
     ========================= */
  const shipDrawerSelector = ".salpi-shipto-drawer";

  function isShipOpen(el) {
    if (!el) return false;

    const ariaHidden = el.getAttribute("aria-hidden");
    if (ariaHidden === "true") return false;
    if (ariaHidden === "false") return true;

    if (el.hasAttribute("hidden")) return false;
    const cs = window.getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden" || cs.opacity === "0") return false;

    const r = el.getBoundingClientRect();
    return r.width > 20 && r.height > 20;
  }

  function syncShipToState() {
    const ship = document.querySelector(shipDrawerSelector);
    const open = isShipOpen(ship);
    HTML.classList.toggle("salpi-shipto-open", open);
  }

  document.addEventListener("DOMContentLoaded", syncShipToState);
  window.addEventListener("load", syncShipToState);

  const mo = new MutationObserver(syncShipToState);
  mo.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["class", "style", "aria-hidden", "hidden", "open"],
  });

  window.addEventListener("click", () => setTimeout(syncShipToState, 0), true);
  window.addEventListener("keydown", () => setTimeout(syncShipToState, 0), true);

 /* =========================================================
   SALPI — Stiletto Drawer Localization (MOBILE) — MINIMAL
   - NO intercepta viewCurrency/viewLanguage (lo hace Stiletto)
   - SOLO intercepta selección final (currency/locale) para submit seguro
   ========================================================= */
(function () {
  "use strict";

  function initSalpiLocMinimal() {
    const drawer = document.querySelector(".drawer-menu[data-drawer-menu]");
    if (!drawer) return;

    if (drawer.dataset.salpiLocMinimal === "1") return;
    drawer.dataset.salpiLocMinimal = "1";

    const form = drawer.querySelector("form.drawer-menu__form");
    const currencyInput = drawer.querySelector("[data-currency-input]");
    const localeInput = drawer.querySelector("[data-locale-input]");
    if (!form) return;

    drawer.addEventListener("click", function (e) {
      const el = e.target.closest("[data-item]");
      if (!el) return;

      const item = el.getAttribute("data-item");
      if (!item) return;

      // Dejar que Stiletto abra/cierre vistas (NO tocar)
      if (item === "viewCurrency" || item === "viewLanguage" || item === "secondaryHeading") return;

      // Selección moneda
      if (item === "currency") {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        const v = el.getAttribute("data-value");
        if (currencyInput && v) currencyInput.value = v;
        form.submit();
      }

      // Selección idioma
      if (item === "locale") {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        const v = el.getAttribute("data-value");
        if (localeInput && v) localeInput.value = v;
        form.submit();
      }
    }, true);
  }

  document.addEventListener("DOMContentLoaded", initSalpiLocMinimal);
  window.addEventListener("load", initSalpiLocMinimal);
})();
})();








